"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _cardItem = _interopRequireDefault(require("./card-item"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _index2 = _interopRequireDefault(require("../../../elements/other/actions/index"));
var _marqueeBox = _interopRequireDefault(require("./marquee-box.js"));
var _filterNav = _interopRequireDefault(require("../../../elements/other/filter-nav"));
var _playButton = _interopRequireDefault(require("../../../elements/buttons/play-button"));
var _TemplateModal = _interopRequireDefault(require("../../../page-body/product-merchandising/template-carousel-section/TemplateModal"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Local Imports
 */

const Container = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "Container",
  class: "pl-c16kvr0c"
});
const ButtonWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ButtonWrapper",
  class: "pl-b1pjrdgx"
});
const Row = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Row",
  class: "pl-rk0vnz4"
});
const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-h1i5ugcu"
});
const Controls = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Controls",
  class: "pl-c9fe6hd"
});

/**
 * TemplateWallSection Component.
 * @module TemplateWallSection
 *
 * @param {Object} props React props
 * @param {String} props._name Tracking
 * @param {Array} props.templates Templates
 * @param {Array} props.categories Filter Active Category Nav
 * @param {Array} props.mainCtas Main CTA Below Carousel
 * @param {String} props.modalExitText Modal Exit Default 'Back'
 * @param {String} props.modalPrimaryButtonText Modal Button Text
 * @param {String} props.modalDisclaimerText Disclaimer in Modal
 * @param {String} props.direction Marquee Slide Direction
 * @param {String} props.backgroundColor Background Color
 * @param {String} props.partial Theme partial
 * @returns {React.ReactElement} TemplateWallSection Component
 * @public
 */
function TemplateWallSection({
  _name,
  templates = [],
  categories = [],
  mainCtas,
  modalExitText,
  modalPrimaryButtonText,
  modalDisclaimerText,
  direction,
  backgroundColor = _intents.default.ux.controlFocused.backgroundColor,
  partial,
  verticalMargin,
  ...rest
}) {
  const [filteredTemplates, setFilteredTemplates] = (0, _react.useState)([]);
  const [play, setPlay] = (0, _react.useState)(true);
  const [selected, setSelected] = (0, _react.useState)(null);
  const [open, setOpen] = (0, _react.useState)(false);
  const {
    width
  } = (0, _patternLibraryUtils.useWindowSize)();
  const velocity = 30;
  const mobileVelocity = 20;
  const acceleration = 1.5;
  const baseVelocity = width > _patternLibraryUtils.size.mobileLg ? velocity : mobileVelocity;
  const bgColorActual = partial ? _intents.default.ux.box.backgroundColor : null;
  const getTemplate = (0, _react.useCallback)(() => templates, [templates]);
  const filterTemp = (0, _react.useCallback)(filterType => {
    // TODO: CMS-30938 : Remove this logic entirely. Should only render item as a React Node.
    return getTemplate().filter(item => {
      const categoryType = /*#__PURE__*/_react.default.isValidElement(item) ? item.props.category : item.category;
      return categoryType === filterType;
    });
  }, [getTemplate]);
  const assignLayoutTypes = templateArr => {
    const singleRowLayout = ['default', 'mobile', 'default', 'mobile', 'default', 'default', 'mobile'];
    const twoRowLayout = [...singleRowLayout, 'mobile', 'default', 'mobile', 'mobile', 'default', 'default', 'mobile', 'default'];
    const layoutArr = templateArr.length > 7 ? twoRowLayout : singleRowLayout;
    return templateArr.map((item, idx) => {
      // TODO: CMS-30938 : Remove this logic entirely. Should only render item as a React Node.
      const layoutType = layoutArr[idx % layoutArr.length];
      return /*#__PURE__*/_react.default.isValidElement(item) ? {
        ...item,
        props: {
          ...item.props,
          layoutType
        }
      } : {
        ...item,
        layoutType
      };
    });
  };
  const handleTemplate = e => {
    const categoryType = e.target.value;
    const filtered = filterTemp(categoryType.toString().toLowerCase());
    const updatedTemplates = assignLayoutTypes(filtered);
    setFilteredTemplates(updatedTemplates);
  };
  const handleModal = id => {
    const selectedIdx = filteredTemplates.findIndex(item => item.id === id);
    setOpen(prevCheck => !prevCheck);
    setSelected(selectedIdx);
  };
  const handleExitModal = () => {
    setOpen(prevCheck => !prevCheck);
    setSelected(null);
  };
  const handleChange = () => setPlay(prevCheck => !prevCheck);
  (0, _react.useEffect)(() => {
    const value = /*#__PURE__*/_react.default.isValidElement(categories[0]) ? categories[0]?.props.value : categories[0]?.value;
    let updatedTemplates = [];
    if (value) {
      updatedTemplates = filterTemp(value);
    } else if (!value && templates?.length >= 8) {
      updatedTemplates = templates.slice(0, 15);
    } else if (!value && templates?.length >= 7) {
      updatedTemplates = templates.slice(0, 7);
    } else if (!value && templates?.length > 0) {
      updatedTemplates = [templates[0]];
    }
    updatedTemplates = assignLayoutTypes(updatedTemplates);
    setFilteredTemplates(updatedTemplates);
    setPlay(false);
  }, [templates, filterTemp]);
  const renderMarqueeBoxes = () => {
    const boxes = [];
    const templateSlices = filteredTemplates.length > 7 ? [[0, 7], [7, 15]] : [[0, 7]];
    const speeds = [baseVelocity, baseVelocity * acceleration];
    templateSlices.forEach(([start, end], index) => {
      if (filteredTemplates.length > start) {
        boxes.push(/*#__PURE__*/_react.default.createElement(_marqueeBox.default, {
          key: index,
          play: !play,
          speed: speeds[index],
          direction: direction
        }, /*#__PURE__*/_react.default.createElement(Row, null, filteredTemplates.slice(start, end).map((item, idx) => {
          return /*#__PURE__*/_react.default.isValidElement(item) ? (/*#__PURE__*/_react.default.cloneElement(item, {
            ...item.props,
            key: item.key || idx,
            modalFn: () => handleModal(item.props.id)
          })) : /*#__PURE__*/_react.default.createElement(_cardItem.default, (0, _extends2.default)({
            key: idx,
            modalFn: () => handleModal(item.id)
          }, item));
        }))));
      }
    });
    return boxes;
  };
  return /*#__PURE__*/_react.default.createElement(Container, {
    padding: "none",
    backgroundColor: bgColorActual ? bgColorActual : (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor),
    partial: partial,
    dataCy: "template-wall-section",
    _name: _name,
    verticalMargin: verticalMargin
  }, /*#__PURE__*/_react.default.createElement(HeadlineWrapper, {
    "data-cy": "headline-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_index.default, rest)), categories.length > 0 && /*#__PURE__*/_react.default.createElement(_filterNav.default, (0, _extends2.default)({
    dataCy: "filter-nav",
    handleAction: handleTemplate
  }, rest), categories), renderMarqueeBoxes(), mainCtas && /*#__PURE__*/_react.default.createElement(ButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_index2.default, {
    actionsLayout: "button-set",
    ctas: mainCtas
  }), /*#__PURE__*/_react.default.createElement(Controls, null, /*#__PURE__*/_react.default.createElement(_playButton.default, {
    dataCy: "play-button",
    handlePlay: handleChange,
    pause: !play,
    size: "small"
  }))), /*#__PURE__*/_react.default.createElement(_TemplateModal.default, {
    selectedTemplate: filteredTemplates[selected],
    exitAction: handleExitModal,
    open: open,
    modalExitText,
    modalPrimaryButtonText,
    modalDisclaimerText
  }));
}
var _default = exports.default = TemplateWallSection;
TemplateWallSection.propTypes = {
  _name: _propTypes.default.string,
  templates: _propTypes.default.arrayOf(_propTypes.default.node),
  categories: _propTypes.default.arrayOf(_propTypes.default.node),
  mainCtas: _propTypes.default.array,
  modalExitText: _propTypes.default.string,
  modalPrimaryButtonText: _propTypes.default.string,
  modalDisclaimerText: _propTypes.default.string,
  direction: _propTypes.default.oneOf(['left', 'right']),
  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    rgb: _propTypes.default.string,
    contrastRgb: _propTypes.default.string
  }), _propTypes.default.shape({
    intent: _propTypes.default.string
  })]),
  partial: _propTypes.default.string,
  ..._patternLibraryUtils.marginProps
};